import type { MapPoint } from './types';
import { useEffect } from 'react';
import { useMap } from 'react-leaflet';

// Pans/zooms the map to a target whenever it changes. Mount as a child of
// `<MapContainer>`. `null` target is a no-op — hosts pass the picked
// search result / selected region centre here to recentre.
//
// Legacy (V2) parity: recentre with a quick `setView` pan
// (`{ animate: true, duration: 1 }`, mirroring `map.tsx`'s
// `handleSearchComplete`) instead of Leaflet's `flyTo`, whose parabolic
// zoom-out-then-in makes the move feel slow.
export const FlyTo = ({
  target,
  zoom,
}: {
  target: MapPoint | null;
  zoom?: number;
}) => {
  const map = useMap();
  const key = target ? `${target.lat},${target.lng},${zoom ?? ''}` : null;
  // biome-ignore lint/correctness/useExhaustiveDependencies: intentional value-gating — `key` already serializes target+zoom by value, so direct deps would re-run on identity-only target changes.
  useEffect(() => {
    if (!target) return;
    map.setView([target.lat, target.lng], zoom ?? map.getZoom(), {
      animate: true,
      duration: 1,
    });
  }, [map, key]);
  return null;
};
